/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Territories { 
    territory?: Array<string>;
    media?: Array<string>;
    additionalMediaInfo?: string;
    startBuyout?: string;
    duration?: string;
    expiryDate?: string;
    noExpiry?: boolean;
}

